import { Button } from '@/components/ui/button'
import { Typography } from '@/components/ui/typography'
import { usePathHelper } from '@/hooks/usePathHelper'
import { useAbility } from '@/lib/casl'
import { useNavigate } from '@tanstack/react-router'

type OrderChangeCancelActionProps = {
  salesOrderId: number
  disabled: boolean
}

/** A draft with every item removed cancels its order, through the order page's cancel flow. */
export function OrderChangeCancelAction({ salesOrderId, disabled }: OrderChangeCancelActionProps) {
  const navigate = useNavigate()
  const path = usePathHelper()
  // As on the order page: cancelling an order takes its own permission.
  const canCancelOrder = useAbility().can('delete', 'sales-orders')

  return (
    <>
      <Button
        variant="destructive"
        className="w-full"
        disabled={disabled || !canCancelOrder}
        onClick={() =>
          void navigate({
            ...path.salesOrders.show(salesOrderId).link,
            search: { cancel: true },
          })
        }
      >
        Cancel order
      </Button>
      <Typography variant="label" tone="muted">
        {canCancelOrder
          ? 'With every item removed, the order is cancelled. Restore an item to keep it.'
          : 'With every item removed, the order would be cancelled, which needs cancellation access. Restore an item, or ask a manager.'}
      </Typography>
    </>
  )
}
